import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=3837039c&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=3837039c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837039c",
  null
  
)

export default component.exports